export function currency(value = 0, currency = 'BRL'): string {
  if (!Intl) return String(value)

  const numberFormat = new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency,
  })

  return numberFormat.format(value)
}

export function dateFromServer(date: string) {
  const pattern = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/

  if (!!date && pattern.test(date)) {
    return date.split('-').reverse().join('/')
  }

  return ''
}

export function dateTimeFromServer(text?: string, includeTime = true) {
  if (!text) return text
  const date = text.length === 10 ? new Date(`${text}T23:59:59Z`) : new Date(text + 'Z')
  return `${date.toLocaleDateString()}` + (includeTime ? ` ${date.toLocaleTimeString()}` : '')
}

export function dateToServer(date: string) {
  const pattern = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i

  if (!!date && pattern.test(date)) {
    return date.split('/').reverse().join('-')
  }

  return ''
}

export function formatAmount(amount: string | number) {
  if (typeof amount === 'string') {
    amount = Number.parseFloat(amount)
  }

  if (typeof amount === 'number' && Number.isFinite(amount)) {
    return amount.toFixed(2)
  } else {
    return ''
  }
}
